import React, { useState, useMemo } from 'react'
import { Button, Form } from 'react-bootstrap'
import { FaCalendarAlt, FaChevronCircleLeft } from 'react-icons/fa';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import utils from '../modules/utils'
import "animate.css"
import moment from 'moment'
import 'moment/locale/it'
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import it from 'date-fns/locale/it';
import { Formatter } from 'gf-ui';
import { formattaOrario } from '../pages';
registerLocale('it', it);

const Settimana = ({ anno, mese, giorniDisp, giorni, onDaySel }) => {  
  return ['lun', 'mar', 'mer', 'gio', 'ven', 'sab', 'dom'].map( (dw, index) => {
    const giorno = giorni.filter(giorno => moment(`${anno}${mese}${giorno}`, 'YYYYMMDD').format('ddd') === dw)
    const settimana = moment(`${anno}${mese}${giorni[0]}`, 'YYYYMMDD').isoWeek()
    const isFestivo = ['dom'].indexOf(dw) >= 0
        
    if (giorno.length > 0) {

      const disponibile = Object.keys(giorniDisp).map(g => g.toString()).indexOf(giorno[0].toString()) >= 0

      return disponibile ? <div key={`${anno}${mese}${settimana}${dw}`} className={`agenda-day present ${isFestivo ? 'festivo' : ''}`} onClick={() => onDaySel(`${anno}${mese}${giorno}`)}>
        <span>{dw}</span>
        {giorno.map(g => {
          return <div key={g}>
            <h1>{g}</h1>
          </div>
        })}
      </div>
        :
        <div key={`${anno}${mese}${settimana}${dw}`} className={`agenda-day ${isFestivo ? 'festivo' : ''}`}>
          <span>{`${dw}`}</span>
          {giorno.map(g => {
            return <div key={g}>
              <h1>{g}</h1>
            </div>
          })}
        </div>
    } else {
      return <div key={`${anno}${mese}${settimana}${dw}`} className={`agenda-day ${isFestivo ? 'festivo' : ''}`} />
    }

  })
}

const Agenda = ({ dati, selectOrario, agenda }) => {

  const [showAgenda, showHideAgenda] = useState(false)
  const [daySel, setDaySel] = useState(null)
  const [orariSel, setOrariSel] = useState(null)

  const anni = useMemo(() => {
    let anni = {}
    if (dati) {
      dati.forEach(data => {
        const anno = Formatter.getDate(data.DATA_APPUNTAMENTO).getFullYear()
        const mese = (Formatter.getDate(data.DATA_APPUNTAMENTO).getMonth() + 1)
        const giorno = Formatter.getDate(data.DATA_APPUNTAMENTO).getDate()

        if (typeof anni[anno] === "undefined") {
          anni[anno] = {};
        }
        if (typeof anni[anno][mese] === "undefined") {
          anni[anno][mese] = {};
        }
        if (typeof anni[anno][mese][giorno] === "undefined" && !isNaN(giorno)) {
          anni[anno][mese][giorno] = []
        }
        if (anni[anno][mese][giorno].indexOf(data.ORARIO) < 0) {
          anni[anno][mese][giorno].push(data.ORARIO)
        }
      })
    }
    return anni
  }, [dati])

  const selezionaOrario = (giorno, orario) => {
    setDaySel(null)
    setOrariSel(null)
    selectOrario(giorno, orario)
    showHideAgenda(false)
  }

  const onDaySel = (giorno) => {
    if (daySel) {
      setDaySel(null)
      setOrariSel(null)
    } else {
      setDaySel(giorno)
    }
  }

  const onDaySelMobile = (giorno) => {
    setDaySel(giorno)
    const anno = Formatter.getDate(giorno).getFullYear()
    const mese = (Formatter.getDate(giorno).getMonth() + 1)
    const gg = Formatter.getDate(giorno).getDate()
    setOrariSel(anni[anno][mese][gg])
  }


  return (
    <div style={{ backgroundColor: 'white', paddingTop: '40px', paddingBottom: '40px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <h3 className="fw-bold mb-4 mx-4 text-center" style={{ color: 'steelblue' }}>Puoi indicare un giorno e un orario di preferenza se vuoi effettuare un consulto</h3>

      {!showAgenda && (
        <Button variant="primary" className="text-light" onClick={(e) => showHideAgenda(true)}>
          <FaCalendarAlt /> {`${agenda.giorno === "" ? 'Voglio selezionare un giorno / orario' : 'Modifica giorno / orario'}`}
        </Button>
      )}

      <div className={`${showAgenda ? 'd-block' : 'd-none'}`}>
        <div style={{ width: '100%', padding: 10, borderRadius: 20, overflow: 'hidden' }} className="agenda-mobile">
          <Form.Group>
            <label style={{ fontSize: '1.5em' }}>Giorno</label>
            <DatePicker minDate={daySel}
              placeholderText="Seleziona un giorno..."
              includeDates={dati.map(data => moment(data.DATA_APPUNTAMENTO, "YYYYMMDD")).map(data => data.toDate())}
              className="form-control"
              onChangeRaw={(e) => e.preventDefault()}
              onChange={(val) => {
                onDaySelMobile(moment(val).format("YYYYMMDD"));
              }}
              selected={daySel ? moment(daySel, "YYYYMMDD").utc().toDate() : null}
              dateFormat="dd/MM/yyyy"
              locale="it" />

            {daySel && (
              <>
                <label style={{ fontSize: '1.5em' }}>Orario</label>
                <Form.Select size="sm" aria-label="Orario" onChange={(e) => selezionaOrario(daySel, e.target.value)}>
                  <option >Seleziona...</option>
                  {orariSel && orariSel.map((orario, idx_orario) =>
                    <option key={idx_orario} value={orario}>{formattaOrario(orario)}</option>
                  )}
                </Form.Select>
              </>
            )}
          </Form.Group>
        </div>

        {anni && <div className="agenda">
          <div style={{ maxWidth: '750px', borderRadius: 20, overflow: 'hidden' }} >
            <Carousel showIndicators={false}
              showStatus={false}
              showArrows={!daySel}
              autoPlay={false}
              interval={100000}
              showThumbs={false}
            >
              {anni && Object.keys(anni).sort().map(anno =>
                anni[anno] && Object.keys(anni[anno]).sort().map(mese => {

                  let lastDayOfMonth = moment(`${anno}${mese}01`, 'YYYYMMDD').endOf('month').format('DD')
                  const GIORNI_MESE = [...Array(parseInt(lastDayOfMonth))].map((_, i) => i + 1).map((giornoCal, idxGiorno) => giornoCal)
                  const SETTIMANE_MESE = [...new Set(GIORNI_MESE.map(giorno => moment(`${anno}${mese}${giorno}`, 'YYYYMMDD').isoWeek()))]

                  const dddSel = moment(daySel, 'YYYYMMDD').format('ddd')
                  const isFestivo = daySel && ['dom'].indexOf(dddSel) >= 0

                  return <div key={`${anno}${mese}`} className={!daySel ? "agenda-container" : "agenda-container-alt"}>
                    <span className="agenda-anno"><strong>{anno}</strong></span>
                    <h1 className="agenda-mese">{utils.getDescMese(mese)}</h1>
                    {!daySel && (
                      <div className={`agenda-days-container`}>
                        {SETTIMANE_MESE.map(settimana => {
                          return (<div key={settimana} className='d-flex flex-row align-items-flex-start justify-content-center'>
                            <Settimana
                              anno={anno}
                              mese={mese}
                              giorniDisp={anni[anno][mese]}
                              giorni={GIORNI_MESE.filter(gm => {
                                const GIORNO = moment(`${anno}${mese}${gm}`, 'YYYYMMDD')
                                const NUM_SETTIMANA_GIORNO = GIORNO.isoWeek()
                                return NUM_SETTIMANA_GIORNO === settimana
                              })}
                              onDaySel={onDaySel}
                            />
                          </div>)
                        })}
                      </div>
                    )}

                    {daySel && (Formatter.getDate(daySel).getMonth() + 1).toString() === mese.toString() && (
                      <div className='w-100 d-flex flex-row align-items-center justify-content-center'>
                        <div className={`agenda-days-container`}>
                          <div className={`agenda-day present ${isFestivo ? 'festivo' : ''}`} onClick={onDaySel}>
                            <span>{dddSel}</span>
                            <h1>{Formatter.getDate(daySel).getDate()}</h1>
                          </div>
                          <div className="orari p-4 animate__animated animate__backInRight">
                            <h3 className="title-fascia-oraria">Orario</h3>
                            <div className="orari-container">
                              {anni[anno][mese][Formatter.getDate(daySel).getDate()].map(orario => {
                                return <div key={orario} className="d-grid gap-2">
                                  <Button variant="outline-primary" className="m-1 orario" onClick={() => selezionaOrario(daySel, orario)}>
                                    {formattaOrario(orario)}
                                  </Button>
                                </div>
                              }
                              )}
                            </div>
                            <div className="arrow arrow-left" />
                          </div>
                        </div>
                        <div className="orari-close" onClick={() => setDaySel(null)}>
                          <FaChevronCircleLeft /> <span>Indietro</span>
                        </div>
                      </div>
                    )}
                  </div>
                })
              )}
            </Carousel>
          </div>
          <div className='p-4 d-flex flex-row align-items-center'><span className='d-flex legenda disponibile'>&nbsp;&nbsp;&nbsp;</span><span className='legenda label'>GIORNI DISPONIBILI</span></div>
        </div>
        }
      </div>
    </div>
  )
}

export default Agenda;
